import styled from "styled-components";
import TextFields from "../UI/TextFields";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import { useEffect, useMemo, useState } from "react";
import SelectBox from "../UI/SelectBox";
import DateRangePickerSingle from "../UI/DateRangePickerSingle";
import { callApi } from "util/HttpService";
import { alert, modalConfirm } from "./CmmnConfirm";

const TableWrap = styled.div`  
    @media (max-width: 1200px) {
        overflow: scroll;
    }
    h2 {
        font-size: 18px;
        color: #3b3b3b;
        font-weight: 500;
        margin-bottom: 15px;
    } 
`;

const InputTable = styled.div`
    // margin-bottom: 20px;
    border-top: 2px solid #EF2929;
    .input-table-th-small{
        max-width: 151px;
        min-width: 151px;
    }
    .input-table-wrap{
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
`;
const InputTableHead = styled.div`
    background-color: #F3F3F3;
    padding: 20px;
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
    max-width: 221px;
    min-width: 151px;
    h3 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        line-height: 150%;
        text-align: center;
    }
`;
const InputTableBody = styled.div`
    display: flex;
    align-items: center;
    padding: 20px;
    width: 100%;
    h4 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 400;
    }
    h5 {
        font-size: 16px;
        color: #3b3b3b;
        font-weight: 500;
        margin-left: 10px;
    }
    .form-select {
        max-width: 250px;
    }
    input[type="text"] {
        max-width: 250px;
        width: 250px;
    }
`;
const BtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate(-51%);
    .btn {
        width: 150px;
        max-width: 150px;
        &:first-child {
            margin-right: 10px;
        }
        &:nth-child(2) {
            margin-right: 10px;
            &:hover {
                color: var(--bs-btn-hover-color);
                background-color: var(--bs-btn-hover-bg);
                border-color: var(--bs-btn-hover-border-color);
            }
        }
        &:first-child:hover,
        &:last-child:hover {
            color: var(--bs-btn-hover-color) !important;
            background-color: var(--bs-btn-hover-bg) !important;
            border-color: var(--bs-btn-hover-border-color) !important;
        }
    }
    .round-filled-small-btn {
        background-color: ${({ theme }) => theme.colors.red} !important;
    }
`;

const DiscountControlWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    width: 100%;
    label {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-right: 6px;
        font-size: 15px;
        color: #3b3b3b;
    }
    .form-select {
        width: 160px;
    }
`;

const DEFAULT_SYSTEM_SETTINGS = {
    discountPeriodUseYn: 'N',
    discountStartMonthDay: '',
    discountEndMonthDay: '',
    discountTimeUseYn: 'N',
    discountStartTime: '',
    discountEndTime: '',
};
const SYSTEM_MODE_VISIBLE_MAP = {    
    FCC: [ "S6", "S7", "S2", "S4", "H1", "H2", "F1", "F3"],
    KSC: [ "S6", "S7", "S2", "S4", "H1", "H2", "F1", "F3"],
};

export default function SystemConfig({
    t,
    brchClsfCd,
    systemModeArray,
    data,
    kiskInfo,
    onHide,
    getKiskInfo,
}) {
    const [systemSettings, setSystemSettings] = useState({});
    useEffect(() => {
        if (kiskInfo && kiskInfo.sysStupCn) {
            const defaultSettings = (brchClsfCd === 'KSC' || brchClsfCd === 'FCC') ? DEFAULT_SYSTEM_SETTINGS : {};
            setSystemSettings({
                ...defaultSettings,
                ...kiskInfo.sysStupCn,
            });
            // console.log(kiskInfo.sysStupCn);
        }
    }, [kiskInfo, brchClsfCd]);

    // useEffect(() => {
    //     console.log(systemSettings);
    // }, [systemSettings]);

    const handleChange = (e, key) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setSystemSettings(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleBirthDayEventDateChange = (e) => {
        const { name, value } = e.target;
        setSystemSettings(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleDiscountPeriodUseChange = (value) => {
        setSystemSettings(prevState => ({
            ...prevState,
            discountPeriodUseYn: value,
            ...(value === 'N'
                ? {
                    discountStartMonthDay: '',
                    discountEndMonthDay: ''
                }
                : {})
        }));
    };

    const handleDiscountTimeUseChange = (value) => {
        setSystemSettings(prevState => ({
            ...prevState,
            discountTimeUseYn: value,
            ...(value === 'N'
                ? {
                    discountStartTime: '',
                    discountEndTime: ''
                }
                : {})
        }));
    };

    const filteredSystemModeArray = useMemo(() => {
        const visibleValues = SYSTEM_MODE_VISIBLE_MAP[brchClsfCd];
        if (!visibleValues) {
            return systemModeArray;
        }
        return systemModeArray.filter(mode => visibleValues.includes(mode.value));
    }, [brchClsfCd, systemModeArray]);

    // PC 종료 시간
    function generateTimeOptions(minuteStep = 10) {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += minuteStep) {
                const formattedHour = String(hour).padStart(2, '0');
                const formattedMinute = String(minute).padStart(2, '0');
                options.push({
                    key: `${formattedHour}:${formattedMinute}`,
                    value: `${formattedHour}:${formattedMinute}`,
                });
            }
        }
        return options;
    };
    const pcShutdownTimeArray = generateTimeOptions();
    const discountTimeArray = generateTimeOptions(10);

    function generateMonthDayOptions() {
        const options = [];
        for (let month = 1; month <= 12; month++) {
            const lastDay = new Date(2000, month, 0).getDate();
            for (let day = 1; day <= lastDay; day++) {
                const monthDay = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                options.push({ key: monthDay, value: monthDay });
            }
        }
        return options;
    };

    const discountMonthDayArray = generateMonthDayOptions();
    // 서비스 기본 언어
    const defaultLangArray = [
        { key: "한국어", value: "ko" },
        { key: "日本語", value: "jp" },
        { key: "English", value: "en" },
        { key: "简体中文", value: "cn" },
        { key: "แบบไทย", value: "th" },
        { key: "Tiếng Việt", value: "vi" },
        { key: "melayu", value: "ms" },
        { key: "Español", value: "es" },
        { key: "Français", value: "fr" },
        { key: "bahasa Indonesia", value: "id" },
    ];
    
    // API 호출 대상 서버
    const targetServerArray = [
        { key: "prod", value: "prod" },
        { key: "dev", value: "dev" }
    ];

    // Iot 보드 포트, 결제기 포트
    const comPortsArray = Array.from({ length: 256 }, (_, i) => ({
        key: `COM${i + 1}`,
        value: `COM${i + 1}`,
    }));
    // 동전투입기 선택
    const coinAcceptorArray = [
        { key: "JY", value: "JY" },
        { key: "VN", value: "VN" },
        { key: "JY-OLD", value: "JY-OLD" },
    ];
    // 프린트 출력 설정
    const printCopiesModeArray = [
        { key: t("systemSetting.optnProdPrintCopiesMode"), value: "prod" },
        { key: t("systemSetting.optnDevPrintCopiesMode"), value: "dev" },
    ];
    // 프린트 드라이버
    const printerDriverArray = [
        { key: "JoySpace", value: "JoySpace" },
        { key: "DnpDsRx1", value: "DnpDsRx1" },
    ];
    // 사진 재촬영 시도 횟수
    const takePhotoRetryCountArray = Array.from({ length: 10 }, (_, i) => ({
        key: (i + 1),
        value: (i + 1)
    }));
    // 지폐수집기 포트
    const billComPortsArray = Array.from({ length: 100 }, (_, i) => ({
        key: `COM${i + 1}`,
        value: `COM${i + 1}`,
    }));
    // 지폐수집기 선택
    const billAcceptorArray = [
        { key: "ict", value: "ict" },
        { key: "oneplus", value: "oneplus" },
    ];
    // 타이틀 화면 컨텐츠
    const titleScreenContentArray = [
        { key: "intro.mp4", value: "intro.mp4" },
        { key: "intro_event.mp4", value: "intro_event.mp4" },
        { key: "intro_dall.mp4", value: "intro_dall.mp4" },
    ];
    // QR 생성 여부
    const qrChkArray = [
        { key: t("systemSetting.optnQrCheckY"), value: "Y"},
        { key: t("systemSetting.optnQrCheckN"), value: "N"},
    ];
    // 배경 적용 여부 배경은 실제 배경을 사용한다는 의미로 적용일경우 키오스 앱의 배경제거 기능을 사용안함을 의미함
    const bgUseArray = [
        { key: t("systemSetting.optnBgUseY"), value: "Y"},
        { key: t("systemSetting.optnBgUseN"), value: "N"},
    ];
    // S3 선택
    const regionArray = [
        { key: "Tokyo", value: "ap-northeast-1"},
        { key: "Sydney", value: "ap-southeast-2"}
    ];

    const handleCmmnBtnClick = async (btnNm) => {
        switch (btnNm) {
            case "cmmnInsertBtn":
                try {
                    const commonParams = { brchId: data.brchId, eqmtId: data.eqmtId, eqmtNo: data.eqmtNo, delYn: 'N' };

                    // systemSettings
                    const systemParams = { ...commonParams, sysStupCn: systemSettings };
                    await callApi("POST", systemParams, "/web/api/dvc-mgt/edm/kisk-insert");
                    console.log("전송된 systemParams : ", systemParams);

                    alert("", t("alert.save"), () => { getKiskInfo() });

                } catch (error) {
                    console.log(error);
                    alert("", t("alert.saveError"), () => { return });
                }
                break;
            case "cmmnResetBtn":
                try {
                    modalConfirm("", t("alert.resetConfirm"), () => {
                        setSystemSettings(kiskInfo.sysStupCn);
                        alert("", t("alert.initSuccessAlert"), () => { });
                    })
                } catch (error) {
                    console.log(error);
                    alert("", t("alert.initFailAlert"), () => { });
                }
                break;
            default: break;
        };
    };

    return (
        <>
            <div className="p-30">
                <TableWrap>
                    <h2>{t("systemSetting.title")}</h2>
                    <InputTable>
                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") && (
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblSystemMode")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={filteredSystemModeArray}
                                        onSelectChange={(e) => handleChange(e, 'systemMode')}
                                        tagName="systemMode"
                                        defaultVal={systemSettings?.systemMode || 'S6'}
                                    />
                                </InputTableBody>
                            </div>
                        )}
                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&(
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblCustomModeLabel")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <TextFields
                                        type="text"
                                        name="customModeLabel"
                                        onChangeValue={(e) => handleChange(e, 'customModeLabel')}
                                        value={systemSettings?.customModeLabel || ""}
                                    />
                                </InputTableBody>
                            </div>
                        )}

                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&(
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblBirthDayEvent")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <DateRangePickerSingle
                                        name="birthDayEventRange"
                                        startName="birthDayEventStartDate"
                                        endName="birthDayEventEndDate"
                                        startDate={systemSettings?.birthDayEventStartDate || ''}
                                        endDate={systemSettings?.birthDayEventEndDate || ''}
                                        onChangeValue={handleBirthDayEventDateChange}
                                    />
                                </InputTableBody>
                            </div>
                        )}
                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&(
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblDiscountPeriod")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <DiscountControlWrap>
                                        <label><input type="radio" name="discountPeriodUseYn" checked={(systemSettings?.discountPeriodUseYn || 'N') === 'Y'} value="Y" onChange={() => handleDiscountPeriodUseChange('Y')} />{t("systemSetting.lblUse")}</label>
                                        <label><input type="radio" name="discountPeriodUseYn" checked={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} value="N" onChange={() => handleDiscountPeriodUseChange('N')} />{t("systemSetting.lblNotSet")}</label>
                                        <SelectBox defaultOptTxt={t("systemSetting.lblStartDate")} dataArray={discountMonthDayArray} onSelectChange={(e) => handleChange(e, 'discountStartMonthDay')} tagName="discountStartMonthDay" defaultVal={systemSettings?.discountStartMonthDay || ''} disabled={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} />
                                        <span>~</span>
                                        <SelectBox defaultOptTxt={t("systemSetting.lblEndDate")} dataArray={discountMonthDayArray} onSelectChange={(e) => handleChange(e, 'discountEndMonthDay')} tagName="discountEndMonthDay" defaultVal={systemSettings?.discountEndMonthDay || ''} disabled={(systemSettings?.discountPeriodUseYn || 'N') === 'N'} />
                                    </DiscountControlWrap>
                                </InputTableBody>
                            </div>
                        )}

                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&(
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblDiscountTime")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <DiscountControlWrap>
                                        <label><input type="radio" name="discountTimeUseYn" checked={(systemSettings?.discountTimeUseYn || 'N') === 'Y'} value="Y" onChange={() => handleDiscountTimeUseChange('Y')} />{t("systemSetting.lblUse")}</label>
                                        <label><input type="radio" name="discountTimeUseYn" checked={(systemSettings?.discountTimeUseYn || 'N') === 'N'} value="N" onChange={() => handleDiscountTimeUseChange('N')} />{t("systemSetting.24hourOperation")}</label>
                                        <SelectBox defaultOptTxt={t("systemSetting.lblStartTime")} dataArray={discountTimeArray} onSelectChange={(e) => handleChange(e, 'discountStartTime')} tagName="discountStartTime" defaultVal={systemSettings?.discountStartTime || ''} disabled={(systemSettings?.discountTimeUseYn || 'N') === 'N'} />
                                        <span>~</span>
                                        <SelectBox defaultOptTxt={t("systemSetting.lblEndTime")} dataArray={discountTimeArray} onSelectChange={(e) => handleChange(e, 'discountEndTime')} tagName="discountEndTime" defaultVal={systemSettings?.discountEndTime || ''} disabled={(systemSettings?.discountTimeUseYn || 'N') === 'N'} />
                                    </DiscountControlWrap>
                                </InputTableBody>
                            </div>
                        )}

                        <div className="input-table-wrap">
                            <InputTableHead>
                                <h3>{t("systemSetting.lblPcShutDown")}</h3>
                            </InputTableHead>
                            <InputTableBody>
                                <SelectBox
                                    defaultOptTxt={t("systemSetting.24hourOperation")}
                                    dataArray={pcShutdownTimeArray}
                                    onSelectChange={(e) => handleChange(e, 'pcShutdownTime')}
                                    tagName="pcShutdownTime"
                                    defaultVal={systemSettings?.pcShutdownTime || ''}
                                />
                            </InputTableBody>
                        </div>
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblEqmtNo")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <TextFields
                                        type="text"
                                        name="eqmtNo"
                                        onChangeValue={(e) => handleChange(e, 'eqmtNo')}
                                        value={systemSettings?.eqmtNo || ""}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        <div className="input-table-wrap">
                            <InputTableHead>
                                <h3>{t("systemSetting.lblServiceDefaultLang")}</h3>
                            </InputTableHead>
                            <InputTableBody>
                                <SelectBox
                                    defaultOptTxt={t("common.selectLable")}
                                    dataArray={defaultLangArray}
                                    onSelectChange={(e) => handleChange(e, 'defaultLang')}
                                    tagName="defaultLang"
                                    defaultVal={systemSettings?.defaultLang || 'jp'}
                                />
                            </InputTableBody>
                        </div>
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblTargetServer")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={targetServerArray}
                                        onSelectChange={(e) => handleChange(e, 'targetServer')}
                                        tagName="targetServer"
                                        defaultVal={systemSettings?.targetServer || 'prod'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblIoTBoardComPort")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={comPortsArray}
                                        onSelectChange={(e) => handleChange(e, 'iotComPort')}
                                        tagName="iotComPort"
                                        defaultVal={systemSettings.iotComPort || 'COM2'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblCoinAcceptorComPort")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={comPortsArray}
                                        onSelectChange={(e) => handleChange(e, 'coinAcceptorComPort')}
                                        tagName="coinAcceptorComPort"
                                        defaultVal={systemSettings.coinAcceptorComPort || 'COM2'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblBillAcceptorComPort")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={billComPortsArray}
                                        onSelectChange={(e) => handleChange(e, 'billAcceptorComPort')}
                                        tagName="billAcceptorComPort"
                                        defaultVal={systemSettings.billAcceptorComPort || 'COM1'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblCoinAcceptorSelect")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={coinAcceptorArray}
                                        onSelectChange={(e) => handleChange(e, 'coinAcceptor')}
                                        tagName="coinAcceptor"
                                        defaultVal={systemSettings.coinAcceptor || 'JY'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblBillAcceptorSelect")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={billAcceptorArray}
                                        onSelectChange={(e) => handleChange(e, 'billAcceptor')}
                                        tagName="billAcceptor"
                                        defaultVal={systemSettings.billAcceptor || 'oneplus'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        <div className="input-table-wrap">
                            <InputTableHead>
                                <h3>{t("systemSetting.lblPrintCopiesModeSelect")}</h3>
                            </InputTableHead>
                            <InputTableBody>
                                <SelectBox
                                    defaultOptTxt={t("common.selectLable")}
                                    dataArray={printCopiesModeArray}
                                    onSelectChange={(e) => handleChange(e, 'printCopiesMode')}
                                    tagName="printCopiesMode"
                                    defaultVal={systemSettings.printCopiesMode || 'prod'}
                                />
                            </InputTableBody>
                        </div>
                        {brchClsfCd === "KSC" && 
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblPrinterDriverSelect")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={printerDriverArray}
                                        onSelectChange={(e) => handleChange(e, 'usePrintDriver')}                            
                                        tagName="usePrintDriver"
                                        defaultVal={systemSettings.usePrintDriver || 'JoySpace'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {brchClsfCd === "KSC" &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblTakePhotoRetryCount")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={takePhotoRetryCountArray}
                                        onSelectChange={(e) => handleChange(e, 'takePhotoRetryCount')}
                                        tagName="takePhotoRetryCount"
                                        defaultVal={systemSettings.takePhotoRetryCount || 5}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblTitleScreenContent")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={titleScreenContentArray}
                                        onSelectChange={(e) => handleChange(e, 'titleScreenContent')}
                                        tagName="titleScreenContent"
                                        defaultVal={systemSettings.titleScreenContent || 'intro.mp4'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {/* QR 생성 여부는 svcKnCd가 PTMG가 아니면 미노출 */}
                        {localStorage.getItem("svcKnCd") === "PTMG" ?
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblQrCheck")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={qrChkArray}
                                        onSelectChange={(e) => handleChange(e, 'qrCheckYn')}
                                        tagName="qrCheckYn"
                                        defaultVal={systemSettings.qrCheckYn || 'Y'}
                                    />
                                </InputTableBody>
                            </div>
                            :<></>
                        }
                        { (brchClsfCd === "KSC" || brchClsfCd === "FCC") &&
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblBgUseYn")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={bgUseArray}
                                        onSelectChange={(e) => handleChange(e, 'bgUseYn')}
                                        tagName="bgUseYn"
                                        defaultVal={systemSettings.bgUseYn || 'Y'}
                                    />
                                </InputTableBody>
                            </div>
                        }
                        {/* 
                        <div className="input-table-wrap">
                            <InputTableHead>
                                <h3>{t("systemSetting.lblQrCheck")}</h3>
                            </InputTableHead>
                            <InputTableBody>
                                <SelectBox
                                    defaultOptTxt={t("common.selectLable")}
                                    dataArray={qrChkArray}
                                    onSelectChange={(e) => handleChange(e, 'qrCheckYn')}
                                    tagName="qrCheckYn"
                                    defaultVal={systemSettings.qrCheckYn || 'Y'}
                                />
                            </InputTableBody>
                        </div>
                        */}
                        {brchClsfCd === "KSC" && 
                            <div className="input-table-wrap">
                                <InputTableHead>
                                    <h3>{t("systemSetting.lblS3Region")}</h3>
                                </InputTableHead>
                                <InputTableBody>
                                    <SelectBox
                                        defaultOptTxt={t("common.selectLable")}
                                        dataArray={regionArray}
                                        onSelectChange={(e) => handleChange(e, 's3Region')}
                                        tagName="s3Region"
                                        defaultVal={systemSettings.s3Region || ''}
                                    />
                                </InputTableBody>
                            </div>
                        }
                    </InputTable>
                </TableWrap>
            </div>
            <BtnWrap>
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.lblInitBtn")}
                    onClick={() => { handleCmmnBtnClick("cmmnResetBtn") }}
                />
                <ButtonUtil className="btn btn-outline-light round-solid-medium-btn"
                    value={t("common.cancelLable")}
                    onClick={() => { onHide() }}
                />
                <ButtonUtil className="btn btn-danger round-filled-small-btn"
                    value={t("common.saveLable")}
                    onClick={() => { handleCmmnBtnClick("cmmnInsertBtn") }}
                />
            </BtnWrap>
        </>
    )

}
